var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0404 11C14.0404 12.6023 12.7647 13.9011 11.1911 13.9011C9.61746 13.9011 8.3418 12.6023 8.3418 11C8.3418 9.39776 9.61746 8.09894 11.1911 8.09894C12.7647 8.09894 14.0404 9.39776 14.0404 11Z",
    stroke: "currentColor",
    strokeWidth: 2.11538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28125 11.0001C2.6045 7.0767 6.54049 4.23083 11.1902 4.23083C15.84 4.23083 19.776 7.07673 21.0992 11.0001C19.776 14.9234 15.84 17.7693 11.1902 17.7693C6.54048 17.7693 2.60448 14.9234 1.28125 11.0001Z",
    stroke: "currentColor",
    strokeWidth: 2.11538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFind);
export default __webpack_public_path__ + "static/media/SearchFind.0022ba7c1edb9cd8bb7b0a73d6c31c36.svg";
export { ForwardRef as ReactComponent };